module.exports = __webpack_public_path__ + "img/Colibri_fond_transparent.923283b6.png";